import { isLightColor, Text, TextProps } from "@mantine/core"

interface Props extends Omit<TextProps, "c" | "bg"> {
  name: string
  rehearseNumber?: number | null
  foreColor?: string | null
  backColor?: string | null
}

// TODO: move to components
export function ActivityTypeText({
  name,
  rehearseNumber,
  foreColor,
  backColor,
  ...props
}: Props) {
  return (
    <Text
      style={{ borderRadius: 5 }}
      px={!!backColor ? 5 : undefined}
      bg={backColor ?? undefined}
      c={
        foreColor && backColor
          ? isLightColor(backColor)
            ? "black"
            : "white"
          : undefined
      }
      w={props.w || "fit-content"}
      {...props}
    >
      {`${name ?? ""}${rehearseNumber ? " " + rehearseNumber : ""}`}
    </Text>
  )
}
